<template>
  <div>
    <el-table
      :data="tableData"
      size="mini"
      header-row-class-name="text-danger"
      :header-cell-style="headerCellStyle"
      :cell-style="cellStyle"
    >
      <el-table-column
        label="Name"
        property="name"
      />
      <el-table-column
        label="Value"
        property="value"
      />
    </el-table>
    <div class="row">
      <div
        style="margin-top:20px;"
        class="col-12 alert alert-info fade show"
      >
        If this information matches you and the course you are being invited to partcipate in, click 'Next'.
      </div>
    </div>
  </div>
</template>

<script>
import formatter from '@/services/formatter.js'

export default {
  name: 'AcceptInvitationScouter',
  props: {
    invitationDetails: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data: function () {
    return {
      tableData: null,
      cellStyle: { padding: '0', height: '20px', 'font-size': '10px' },
      headerCellStyle: { padding: '0', height: '20px', 'font-size': '10px', 'text-align': 'left', 'overflow-wrap': 'break-word' }
    }
  },
  computed: {
    startDateValue: function () {
      return formatter.formatAsDate(this.invitationDetails.CourseStartDate)
    }
  },
  mounted: function () {
    this.refresh()
  },
  methods: {
    refresh: function () {
      this.tableData = [{
        name: 'Scouter\'s Name',
        value: this.invitationDetails.ScouterName
      },
      {
        name: 'Email Address',
        value: this.invitationDetails.ScouterEmail
      },
      {
        name: '',
        value: ''
      },
      {
        name: 'Course',
        value: this.invitationDetails.CourseName
      },
      {
        name: 'Council',
        value: this.invitationDetails.CourseCouncil
      },
      {
        name: 'Start Date',
        value: this.startDateValue
      },
      {
        name: 'Course Director',
        value: this.invitationDetails.CourseDirector
      }]
    },
    validate: function () {
      return true
    }
  }
}
</script>
